export const LayoutType = {
  Grid: 'grid',
  Table: 'table',
} as const;

export type LayoutType = typeof LayoutType[keyof typeof LayoutType];
